
import { Job } from '@/types/job';

export const jobListings: Job[] = [
  {
    id: '1',
    title: 'Software Engineer',
    company: 'Tech Innovations Inc.',
    location: 'San Francisco, CA',
    salary: '$120,000 - $150,000',
    description: 'We are looking for a skilled software engineer to join our dynamic team. The ideal candidate should have experience in React, Node.js, and TypeScript.',
    requirements: ['Bachelor\'s degree in Computer Science', '3+ years of experience', 'Proficiency in React, Node.js, TypeScript'],
    postedDate: '2023-11-15',
    type: 'Full-time',
    experience: 'Mid-Senior Level',
    companySize: '200-500 employees',
    industry: 'Software Development',
    skills: ['React', 'Node.js', 'TypeScript', 'JavaScript', 'HTML', 'CSS'],
    companyLogo: 'https://example.com/tech-innovations-logo.png',
    matchScore: 92,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2023-12-31',
    companyRating: 4.5,
    companyWebsite: 'https://techinnovations.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-11-15",
  },
  {
    id: '2',
    title: 'Data Scientist',
    company: 'Analytics Pro',
    location: 'New York, NY',
    salary: '$110,000 - $140,000',
    description: 'Join our team as a Data Scientist and help us analyze complex datasets to drive business decisions. Experience with Python, machine learning, and data visualization is required.',
    requirements: ['Master\'s degree in Statistics or related field', '2+ years of experience', 'Proficiency in Python, machine learning'],
    postedDate: '2023-11-20',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '50-200 employees',
    industry: 'Data Analytics',
    skills: ['Python', 'Machine Learning', 'Data Visualization', 'SQL'],
    companyLogo: 'https://example.com/analytics-pro-logo.png',
    matchScore: 88,
    remote: true,
    jobType: 'Full-time',
    applicationDeadline: '2024-01-15',
    companyRating: 4.2,
    companyWebsite: 'https://analyticspro.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-11-20",
  },
  {
    id: '3',
    title: 'UX Designer',
    company: 'Creative Solutions Ltd.',
    location: 'London, UK',
    salary: '£50,000 - £70,000',
    description: 'We are seeking a talented UX Designer to create intuitive and engaging user experiences for our web and mobile applications. Experience with Figma, Sketch, and Adobe Creative Suite is essential.',
    requirements: ['Bachelor\'s degree in Design or related field', '3+ years of experience', 'Proficiency in Figma, Sketch, Adobe Creative Suite'],
    postedDate: '2023-11-25',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '10-50 employees',
    industry: 'Design',
    skills: ['Figma', 'Sketch', 'Adobe Creative Suite', 'User Research', 'Wireframing'],
    companyLogo: 'https://example.com/creative-solutions-logo.png',
    matchScore: 95,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2024-02-28',
    companyRating: 4.8,
    companyWebsite: 'https://creativesolutions.co.uk',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-11-25",
  },
  {
    id: '4',
    title: 'Project Manager',
    company: 'Global Tech Corp',
    location: 'Berlin, Germany',
    salary: '€60,000 - €80,000',
    description: 'We are looking for an experienced Project Manager to oversee and coordinate projects from initiation to completion. Strong leadership and communication skills are required.',
    requirements: ['Bachelor\'s degree in Business Administration or related field', '5+ years of experience', 'PMP certification'],
    postedDate: '2023-12-01',
    type: 'Full-time',
    experience: 'Senior Level',
    companySize: '500+ employees',
    industry: 'Technology',
    skills: ['Project Management', 'Leadership', 'Communication', 'PMP', 'Agile'],
    companyLogo: 'https://example.com/global-tech-logo.png',
    matchScore: 90,
    remote: true,
    jobType: 'Full-time',
    applicationDeadline: '2024-03-15',
    companyRating: 4.6,
    companyWebsite: 'https://globaltech.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-01",
  },
  {
    id: '5',
    title: 'Frontend Developer',
    company: 'Web Solutions Inc.',
    location: 'Austin, TX',
    salary: '$100,000 - $130,000',
    description: 'Join our team as a Frontend Developer and help us build beautiful and responsive web applications. Experience with React, Angular, or Vue.js is required.',
    requirements: ['Bachelor\'s degree in Computer Science or related field', '2+ years of experience', 'Proficiency in React, Angular, or Vue.js'],
    postedDate: '2023-12-05',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '20-50 employees',
    industry: 'Web Development',
    skills: ['React', 'Angular', 'Vue.js', 'JavaScript', 'HTML', 'CSS'],
    companyLogo: 'https://example.com/web-solutions-logo.png',
    matchScore: 85,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2024-04-30',
    companyRating: 4.3,
    companyWebsite: 'https://websolutions.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-05",
  },
  {
    id: '6',
    title: 'Backend Developer',
    company: 'Web Solutions Inc.',
    location: 'New York, NY',
    salary: '$110,000 - $140,000',
    description: 'Join our team as a Backend Developer and help us build robust and scalable web applications. Experience with Node.js, Python, or Java is required.',
    requirements: ['Bachelor\'s degree in Computer Science or related field', '2+ years of experience', 'Proficiency in Node.js, Python, or Java'],
    postedDate: '2023-12-05',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '20-50 employees',
    industry: 'Web Development',
    skills: ['Node.js', 'Python', 'Java', 'SQL', 'RESTful APIs'],
    companyLogo: 'https://example.com/web-solutions-logo.png',
    matchScore: 85,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2024-04-30',
    companyRating: 4.3,
    companyWebsite: 'https://websolutions.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-05",
  },
  {
    id: '7',
    title: 'Mobile App Developer',
    company: 'App Creations Ltd.',
    location: 'London, UK',
    salary: '£55,000 - £75,000',
    description: 'We are seeking a talented Mobile App Developer to create innovative and user-friendly mobile applications. Experience with React Native, Swift, or Kotlin is essential.',
    requirements: ['Bachelor\'s degree in Computer Science or related field', '3+ years of experience', 'Proficiency in React Native, Swift, or Kotlin'],
    postedDate: '2023-12-10',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '10-30 employees',
    industry: 'Mobile App Development',
    skills: ['React Native', 'Swift', 'Kotlin', 'iOS', 'Android'],
    companyLogo: 'https://example.com/app-creations-logo.png',
    matchScore: 92,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2024-05-15',
    companyRating: 4.7,
    companyWebsite: 'https://appcreations.co.uk',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-10",
  },
  {
    id: '8',
    title: 'AI/ML Engineer',
    company: 'AI Solutions GmbH',
    location: 'Berlin, Germany',
    salary: '€70,000 - €90,000',
    description: 'We are looking for an AI/ML Engineer to develop and implement machine learning models and algorithms. Strong knowledge of Python, TensorFlow, and PyTorch is required.',
    requirements: ['Master\'s degree in Computer Science or related field', '2+ years of experience', 'Proficiency in Python, TensorFlow, PyTorch'],
    postedDate: '2023-12-15',
    type: 'Full-time',
    experience: 'Mid-Senior Level',
    companySize: '30-70 employees',
    industry: 'Artificial Intelligence',
    skills: ['Python', 'TensorFlow', 'PyTorch', 'Machine Learning', 'Deep Learning'],
    companyLogo: 'https://example.com/ai-solutions-logo.png',
    matchScore: 95,
    remote: true,
    jobType: 'Full-time',
    applicationDeadline: '2024-06-30',
    companyRating: 4.9,
    companyWebsite: 'https://aisolutions.de',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-15",
  },
  {
    id: '9',
    title: 'Data Analyst',
    company: 'Analytics Pro',
    location: 'San Francisco, CA',
    salary: '$90,000 - $120,000',
    description: 'Join our team as a Data Analyst and help us analyze data to identify trends and insights. Experience with SQL, Excel, and data visualization tools is required.',
    requirements: ['Bachelor\'s degree in Statistics or related field', '1+ years of experience', 'Proficiency in SQL, Excel, data visualization'],
    postedDate: '2023-12-20',
    type: 'Full-time',
    experience: 'Entry-Level',
    companySize: '50-200 employees',
    industry: 'Data Analytics',
    skills: ['SQL', 'Excel', 'Data Visualization', 'Tableau', 'Power BI'],
    companyLogo: 'https://example.com/analytics-pro-logo.png',
    matchScore: 88,
    remote: false,
    jobType: 'Full-time',
    applicationDeadline: '2024-07-15',
    companyRating: 4.2,
    companyWebsite: 'https://analyticspro.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-20",
  },
  {
    id: '10',
    title: 'Cybersecurity Analyst',
    company: 'Secure Systems Inc.',
    location: 'New York, NY',
    salary: '$100,000 - $130,000',
    description: 'We are seeking a Cybersecurity Analyst to protect our systems and data from cyber threats. Experience with security tools and protocols is required.',
    requirements: ['Bachelor\'s degree in Cybersecurity or related field', '2+ years of experience', 'Proficiency in security tools and protocols'],
    postedDate: '2023-12-25',
    type: 'Full-time',
    experience: 'Mid-Level',
    companySize: '20-50 employees',
    industry: 'Cybersecurity',
    skills: ['Security Tools', 'Security Protocols', 'Network Security', 'Incident Response'],
    companyLogo: 'https://example.com/secure-systems-logo.png',
    matchScore: 90,
    remote: true,
    jobType: 'Full-time',
    applicationDeadline: '2024-08-31',
    companyRating: 4.5,
    companyWebsite: 'https://securesystems.com',
    interviews: [],
    logo: "https://placehold.co/400x225",
    hours: "40 hrs/week",
    posted: "2023-12-25",
  },
];
